import asyncComponent from '../common/utils/async-component';

const ContentSearchContainer = asyncComponent(async () => import('./components/list'));
const ContentEdit = asyncComponent(async () => import('./components/site-edit'));

export default {
  '/sites': {
    components: { main: ContentSearchContainer },

    '/create': {
      components: { main: ContentEdit }
    },
    '/:contentId': {
      components: { main: ContentEdit }
    }
  }
};
